import React, { useRef } from 'react';
import { SVG, Icons } from '../../../components/atoms/SVG';
import { Tooltip, TooltipPlacement } from '../../../components/atoms/Tooltip';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { createExtender } from '../../../lib/bemUtils/bem';

interface ResetButtonProps {
  onClick: (event: React.FormEvent) => void;
  focus: boolean;
  hasInputValue: boolean;
}

export function SearchFormResetButton({ onClick, focus, hasInputValue }: ResetButtonProps) {
  const { t } = useSonTranslation('SearchForm');
  const buttonRef = useRef<HTMLButtonElement>(null);

  const extender = createExtender('search-form__reset-wrapper');
  const isVisible = focus && hasInputValue;

  return (
    <Tooltip attachTo={buttonRef} placement={TooltipPlacement.BOTTOM}>
      <span
        className={
          extender([isVisible ? 'search-form__reset-wrapper--visible' : 'search-form__reset-wrapper--invisible'])
        }
      >
        <button
          type="reset"
          ref={buttonRef}
          className="search-form__reset"
          title={t('search.deletesearch')}
          tabIndex={isVisible ? 0 : -1}
          onClick={onClick}
          aria-label={t('search.deletesearch')}
        >
          <span className="invisible">{t('search.deletesearch')}</span>
          <SVG svgSpriteId={Icons.DECLINE_CROSS} inverted svgClass="search-form__svg-reset" />
        </button>
      </span>
    </Tooltip>
  );
}
